import {
  getRequestsMonitoringMetric,
  type GetRequestsMonitoringMetricKey,
  type GetRequestsQuery,
} from "@synthesis/shared-services/internal/application/types";

// Keep links created before the monitoring API was available working.
const LEGACY_METRICS: Record<string, GetRequestsMonitoringMetricKey> = {
  "system-total": "TOTAL",
  "system-active": "ACTIVE",
  "system-approved": "TU_ISSUED",
  "system-rejected": "REJECTED",
  "system-paid-service": "PAID_SERVICE",
  "system-no-payment": "FREE_SERVICE",
  "system-invoices-total": "INVOICE_TOTAL",
  "system-payments-received": "PAYMENT_TOTAL",
  "system-debt": "DEBT_TOTAL",
  "active-on-schedule": "ACTIVE_PLANNED",
  "active-approaching": "ACTIVE_APPROACHING",
  "active-risk": "ACTIVE_AT_RISK",
  "active-overdue": "ACTIVE_OVERDUE",
  "active-undefined": "ACTIVE_UNDEFINED_PAYMENT",
  "active-paid-service": "ACTIVE_PAID_SERVICE",
  "active-no-payment": "ACTIVE_FREE_SERVICE",
  "active-awaiting-invoice": "ACTIVE_AWAITING_INVOICE",
  "active-awaiting-payment": "ACTIVE_AWAITING_PAYMENT",
  "active-paid": "ACTIVE_PAID",
  "active-invoices-total": "ACTIVE_INVOICE_TOTAL",
  "active-payments-received": "ACTIVE_PAYMENT_TOTAL",
  "active-debt": "ACTIVE_DEBT_TOTAL",
};

export const resolveMonitoringMetric = (metricId: string | null): GetRequestsMonitoringMetricKey | undefined =>
  metricId ? (LEGACY_METRICS[metricId] ?? Object.values(getRequestsMonitoringMetric).find((metric) => metric === metricId)) : undefined;

export const getMonitoringRequestFilters = (metricId: string | null): GetRequestsQuery => {
  const monitoringMetric = resolveMonitoringMetric(metricId);
  return monitoringMetric ? { monitoringMetric } : {};
};
